<script setup lang="ts">
import { ref, onMounted } from "vue";
import { InboxIcon, CheckIcon, ArrowRightIcon } from "../icons";
import { api, errorText, dateTime } from "../api";
const notifications = ref<any[]>([]),
  error = ref("");
onMounted(async () => {
  try {
    notifications.value = await api("/api/notifications");
  } catch (e) {
    error.value = errorText(e);
  }
});
async function read(n: any) {
  try {
    await api("/api/notifications/" + n.id + "/read", { method: "POST" });
    n.read_at = new Date().toISOString();
  } catch (e) {
    error.value = errorText(e);
  }
}
</script>
<template>
  <div class="page-heading">
    <div>
      <h1>Din indbakke</h1>
      <p class="subtitle">De ændringer, der fortjener din opmærksomhed.</p>
    </div>
  </div>
  <p v-if="error" class="error" role="alert">{{ error }}</p>
  <div v-if="!notifications.length" class="empty-state">
    <InboxIcon :size="32" />
    <h2>Her er ro lige nu</h2>
    <p>Beskeder fra dine regler og rapporter lander her.</p>
  </div>
  <article
    v-for="n in notifications"
    :key="n.id"
    class="notification"
    :class="{ unread: !n.read_at }"
  >
    <span v-if="!n.read_at" class="status-dot" />
    <div>
      <small class="muted">{{ dateTime(n.created_at) }}</small>
      <h2>{{ n.title }}</h2>
      <p>{{ n.body }}</p>
      <RouterLink :to="'/datasets/' + n.dataset_id" class="text-button"
        >Åbn datasæt<ArrowRightIcon :size="16"
      /></RouterLink>
    </div>
    <button
      v-if="!n.read_at"
      class="icon-button"
      aria-label="Markér som læst"
      @click="read(n)"
    >
      <CheckIcon :size="19" />
    </button>
  </article>
</template>
